<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

export default {

	page: {
		title: 'Тарификация услуг операторов',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader },

	data() {
		return {
			title: 'Тарификация услуг операторов',
			items: [],
            tableData: [],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: null,
            sortBy: null,
            sortDesc: false,
            fields: [
                { key: 'select',   label: '', row:{'rowSelected':false}},
                { key: 'product_name',  label: 'Категория услуги', sortable: true },
                { key: 'operator_name', label: 'Оператор', sortable: true },
                { key: 'name',   label: 'Название', sortable: true },
                { key: 'qnt',    label: 'Количество', sortable: true },
                { key: 'unit',   label: 'Ед.измерения', sortable: true },
                { key: 'rate',   label: 'Ставка', sortable: true },
                { key: 'status', label: 'Статус'},
                { key: 'action', label: ''}
            ],
            tableLoading: true,
            watch: false,
		}
	},

    watch: {
        sortBy: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        sortDesc: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        perPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangePerPage();
                }
            }
        },
        currentPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangeCurrentPage();
                }
            }
        },
    },
    computed: {
        total_rows() {
            return this.$store.getters['operatorsTariffs/GET_OPERATORS_TARIFFS_TOTAL_ROWS'];
        },
        table_data() {
            this.tableLoading = false;
            return this.$store.getters['operatorsTariffs/GET_OPERATORS_TARIFFS_TABLE_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        session_item(){
            return this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        }
    },

	async mounted() {
        await this.getData();
	},

	methods: {
        async onFiltered() {
            this.currentPage = 1;
            await this.getData();
        },
        async onSorted(){
            await this.getData();
        },
        async onChangePerPage(){
            this.currentPage = 1;
            await this.getData();
        },
        async onChangeCurrentPage(){
            await this.getData();
        },
        async getData(){

            this.tableLoading = true;
            let data_send = {
                'limit'    : this.perPage,
                'page'     : this.currentPage,
                'sortBy'   : this.sortBy,
                'sortDesc' : this.sortDesc === false ? 'ASC' : 'DESC',
                'filter'   : this.filter,
                'filterOn' : JSON.stringify(this.filterOn)
            }

            await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_LIST', data_send);
            this.watch = true;
        }
	},
}
</script>

<template>
	<Layout>
        <div class="row page-title align-items-center">
            <div class="col-sm-4 col-xl-6">
                <h4 class="mb-1 mt-0"><i class="feather uil uil-calculator-alt"></i>{{ title }}</h4>
            </div>
            <div class="col-sm-8 col-xl-6">
                <form class="form-inline float-sm-right mt-3 mt-sm-0">
                    <div class="btn-group">
                        <router-link to="/account/operators/tariffs/create" class="btn btn-primary" right>
                            <i class="uil uil-plus "  style="margin-right: 5px"></i>Добавить услугу
                        </router-link>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">

                <div class="row" style="margin-top: 20px; margin-bottom: 5px">
                    <div class="col-sm-6 col-md-6">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Показывать&nbsp;
                                <b-form-select
                                    v-model="perPage"
                                    size="md"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;записей
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-6 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <label class="d-inline-flex align-items-center">
                                Поиск:
                                <b-form-input
                                    v-model="filter"
                                    type="search"
                                    @change="onFiltered()"
                                    placeholder="Введите текст..."
                                    class="form-control form-control-md ml-2"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>

                <div class="card">
                    <div class="card-body" style="padding-left: 0px; padding-right: 0px;">

                        <div class="table-responsive mb-0">
                            <b-table
                                :items="table_data"
                                :fields="fields"
                                responsive="sm"
                                current-page="1"
                                :class = "tableLoading ? 'loading' : ''"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                            >
                                <template #cell(action)="row">
                                    <div style="text-align: right;">
                                        <router-link :to="{ name: 'Operators.Tariffs.edit', params: { operator_tariff_uuid: row.item.uuid }}" :id="row.item.id+'_edit'" class="btn btn-light btn-sm" style="margin-right: 3px">
                                            <b-tooltip :target="row.item.id+'_edit'" placement="top">Редактировать</b-tooltip>
                                            <i class="uil uil-pen "></i>
                                        </router-link>
                                        <router-link :to="{ name: 'Operators.Tariffs.edit', params: { operator_tariff_uuid: row.item.uuid, copy: true }}" :id="row.item.id+'_copy'" class="btn btn-light btn-sm">
                                            <b-tooltip :target="row.item.id+'_copy'" placement="top">Копировать</b-tooltip>
                                            <i class="uil uil-copy "></i>
                                        </router-link>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        
                    </div>
                </div>

                <div class="row" style="margin-bottom: 30px">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-left"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
	</Layout>
</template>

<style>
.table-responsive-sm{
    transition: all .5s;
}
.table-responsive-sm.loading{
    opacity: 0.3;
}
</style>